/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dizzy_Maroon_Buzzard_ClipInputs */

const fr_dizzy_maroon_buzzard_clip = /** @type {(inputs: Dizzy_Maroon_Buzzard_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edition Role`)
};

/**

* @param {Dizzy_Maroon_Buzzard_ClipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dizzy_maroon_buzzard_clip = /** @type {((inputs?: Dizzy_Maroon_Buzzard_ClipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dizzy_Maroon_Buzzard_ClipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dizzy_maroon_buzzard_clip(inputs)
});